// this would be content.js, but I already have and don't want to convert
// content.coffee

import { httpPOST, json } from './utils.js';
import { toID } from '../reducers/utils.js';
import { getContent } from './content';
import { fetchSection } from './section';
import { newNotification } from './notifications.js';
import { ICONS } from '../const';

const importNewContent = (sections, resource_uri) => dispatch => {
    dispatch(getContent(toID(resource_uri))).then(content => {
        sections.forEach(id => dispatch(fetchSection(id)));
    });
};

export const createLink = ({
    title,
    url,
    sections,
    description,
    embed,
}) => dispatch => {
    httpPOST('/api/v3/repository/externallink/', null, {
        formData: {
            title,
            url,
            description,
            embed,
            sections: sections.join(','),
        },
    })
        .then(json)
        .then(response => {
            dispatch(
                newNotification('Link created', `Created link ${title}`, {
                    icon: ICONS.SUCCESS,
                })
            );
            response.objects.map(({ resource_uri }) =>
                dispatch(importNewContent(sections, resource_uri))
            );
        })
        .catch(() => {
            dispatch(
                newNotification(
                    'Error',
                    'Please try submitting your link again',
                    {
                        icon: ICONS.FAIL,
                        dismissable: true,
                    }
                )
            );
        });
};



// WEBPACK FOOTER //
// ./src/actions/material.js